<div *ngIf="showModal" class="modal-container">
  <div class="modal-dialog">
    <div class="modal-content" id="modal">
      <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center">
        <h1>{{toolData?.toolNm || 'New Tool'}}</h1>
        <button class="pos-right btn-plane- cursor" id="close-Modal" (click)="onCloseModal()">
          <em class="fa fa-times" aria-hidden="true"></em>
        </button>
      </div>

      <!--Form start-->
      <form [formGroup]="toolForm">
        <div class="modal-body modal-scroll">
          <div id="container" class="toggleBtn"> <mat-label class="label">Active :</mat-label>
            <mat-slide-toggle [id]="tourGuideIds.adminContent.tools.toggleBtn.id" color="primary"
              formControlName="active"></mat-slide-toggle>
          </div>
          <div [id]="tourGuideIds.adminContent.tools.primaryInfo.id">
            <h4>Primary information</h4>
            <div fxLayoutAlign="center" *ngIf="showMissingFieldError" class="error-message">
              Some fields are missing*
            </div>
            <!--Primary information-->
            <div class="row row-form-field">

              <mat-form-field appearance="fill">
                <mat-label>{{toolsName}}</mat-label>
                <input matInput [placeholder]="toolsName" formControlName="tool" required minlength="1" #input
                  maxlength="100" [disabled]="disable">
                <mat-hint *ngIf="input.value.length >= 100">Max 100 characters only</mat-hint>
                <mat-hint align="end">{{input.value.length}}/100</mat-hint>
                <mat-error *ngIf="toolForm.get('tool')?.invalid">{{ getToolErrMsg() }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>{{toolsVersion}}</mat-label>
                <input matInput [placeholder]="toolsVersion" formControlName="version" required minlength="1">
                <mat-error *ngIf="toolForm.get('version')?.invalid">{{ getVersionErrMsg() }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>{{selectTypes}}</mat-label>
                <mat-select formControlName="type" required class="capitalize" (selectionChange)="onSelectType($event)">
                  <mat-option *ngFor="let license of selectLicense" [value]="license" class="capitalize">
                    {{ license }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="toolForm.get('type')?.invalid">{{ getTypeErrMsg() }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>{{selectOs}}</mat-label>
                <mat-select formControlName="os" required>
                  <mat-option *ngFor="let toolOsName of selectOperatingSystem" [value]="toolOsName">
                    {{ toolOsName }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="toolForm.get('os')?.invalid">{{ getOsErrMsg() }}</mat-error>
              </mat-form-field>
            </div>
            <!--End primary information-->

            <!--Floating server div-->
            <div class="lic_config" *ngIf="showConfig || toolForm.get('type')?.value === 'licensed'">
              <h4>License configuration <span (click)="toggleFloatInp()" *ngIf="!showFloatInp"
                  [matTooltip]="'Add floating license'">
                  <mat-icon color="primary">add</mat-icon></span></h4>
              <div class="floating_lic" *ngIf="showFloatInp">
                <h4>Add new floating license</h4>
                <div class="row">
                  <mat-form-field appearance="fill">
                    <mat-label>{{name}}</mat-label>
                    <input matInput class="form-input" [placeholder]="fltLicName" name="toolType" id="toolType"
                      formControlName="toolType" required minlength="1">
                    <mat-error *ngIf="toolForm.get('toolType')?.invalid">{{ gettoolTypeErrMsg() }}</mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>{{ipAddr}}</mat-label>
                    <input matInput class="form-input" [placeholder]="ipAddr" name="ipAddr" id="ipAddr"
                      formControlName="ipAddr" required pattern={{ipAddrPattern}}>
                    <mat-error *ngIf="toolForm.get('ipAddr')?.invalid">{{ getIpAddrErrMsg() }}</mat-error>
                  </mat-form-field>
                  <span>
                    <button mat-icon-button color="primary" [matTooltip]="'Save'" (click)="saveFltLicDet($event)"
                      [disabled]="!toolForm.get('toolType')?.valid || !toolForm.get('ipAddr')?.valid">
                      <mat-icon>save</mat-icon>
                    </button>
                    <mat-icon color="warn" [matTooltip]="'Cancel'" (click)="toggleFloatInp()">cancel</mat-icon>
                  </span>
                </div>
              </div>

              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{selectFltType}}</mat-label>
                <mat-select formControlName="fltLicNm" required class="capitalize"
                  (selectionChange)="onSelectType($event)">
                  <mat-option *ngFor="let fltLic of selectFltLicense" [value]="fltLic" class="capitalize">
                    {{ fltLic }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="toolForm.get('type')?.invalid">{{ getTypeErrMsg() }}</mat-error>
              </mat-form-field>
            </div>
            <!--End of floating server div-->
          </div>
          <div>
            <div [id]="tourGuideIds.adminContent.tools.resourceLimit.id">
              <h4>Resource limit</h4>
              <!--Resource limit-->
              <div class="row resource_row">
                <mat-form-field appearance="fill"
                  [ngClass]="{ 'disabled-cursor': toolForm.get('available')?.disabled }">
                  <mat-label
                    [ngClass]="{ 'disabled-cursor': toolForm.get('available')?.disabled }">{{avlCount}}</mat-label>
                  <input matInput class="form-input" placeholder="Available count" type="number" name="Available"
                    id="Available" formControlName="available" required minlength="1" min="0" pattern="\d+"
                    [ngClass]="{ 'disabled-cursor': toolForm.get('available')?.disabled }">
                  <mat-error *ngIf="toolForm.get('available')?.invalid">{{ getAvailErrMsg() }}</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" [ngClass]="{ 'disabled-cursor': toolForm.get('minCnt')?.disabled }">
                  <mat-label
                    [ngClass]="{ 'disabled-cursor': toolForm.get('minCnt')?.disabled }">{{minCount}}</mat-label>
                  <input matInput class="form-input" placeholder="Minimum count" type="number" name="minCnt" id="minCnt"
                    formControlName="minCnt" required minlength="1" min="0" pattern="\d+"
                    [ngClass]="{ 'disabled-cursor': toolForm.get('available')?.disabled }">
                  <mat-error *ngIf="toolForm.get('minCnt')?.invalid">{{ getminCntErrMsg() }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <!--End resource limit-->

            <!--Quality gates component-->
            <div [id]="tourGuideIds.adminContent.tools.qualityGates.id">
              <h4>Quality gates</h4>
              <div><quality-gates-cnfg (savedData)="saved($event)" [dataSource]="qgdatasource"
                  [addtool]='addtool'></quality-gates-cnfg></div>
            </div>
          </div>
          <!--End of quality gates component-->
        </div>

        <!--Save and cancel functionality-->
        <div class="modal-footer">
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10">
            <button mat-flat-button color="primary"
              [id]="tourGuideIds.adminContent.tools.modalSaveBtn.id" type="submit" (click)="onSubmit()"
              *ngIf="!isEditMode">Save</button>
            <button mat-flat-button color="primary" *ngIf="isEditMode" (click)="update()" type="submit">Update</button>
            <button mat-stroked-button color="primary" type="button"
              (click)="onCloseModal()">Cancel</button>
          </div>
        </div>
        <!--End of save and cancel functionality-->
      </form>
      <!--Form end-->
    </div>
  </div>
</div>